import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1a6f02a8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1a6f02a8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6f02a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a6f02a8')) {
      api.createRecord('1a6f02a8', component.options)
    } else {
      api.reload('1a6f02a8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1a6f02a8&scoped=true", function () {
      api.rerender('1a6f02a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/charts/index.vue"
export default component.exports